import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "centered-card" }
const _hoisted_2 = { class: "prices" }
const _hoisted_3 = { class: "button-cont" }

import { useRouter } from "vue-router";
import { useUserStore } from "@/stores/user";
import { ref, onMounted } from "vue";

interface User {
is_subscribed: boolean;
id?: string;
name?: string;
email?: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'PricingPage',
  setup(__props) {

const router = useRouter();
const userStore = useUserStore();
const user = ref<User | null>(null);

onMounted(async () => {
  try {
      user.value = await userStore.fetchUser();
  } catch (error) {
      console.error('Failed to fetch user:', error);
  }
});

const goToHome = (): void => {
  router.push("/");
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _cache[0] || (_cache[0] = _createStaticVNode("<h1 class=\"pricing yellow\" data-v-35066d0f>Pricing</h1><p class=\"subtitle-center\" data-v-35066d0f> Get started with the cheapest image <br data-v-35066d0f> generation tool on the market <span class=\"offer\" data-v-35066d0f>only 0.018$ per image!</span></p><div class=\"cards\" data-v-35066d0f><div class=\"card-pricing\" data-v-35066d0f><h1 class=\"pricing-title green\" data-v-35066d0f>Subscribe</h1><div class=\"discount\" data-v-35066d0f><h2 class=\"crossed\" data-v-35066d0f>12.99$</h2><span class=\"true offer\" data-v-35066d0f>8.99$</span></div><ul class=\"pricing-list\" data-v-35066d0f><li class=\"list-item\" data-v-35066d0f>500 prompts</li><li class=\"list-item\" data-v-35066d0f>unlimited storage</li><li class=\"list-item\" data-v-35066d0f>Email support</li><li class=\"list-item\" data-v-35066d0f>Export to PRF/Print</li></ul></div><div class=\"card-pricing\" data-v-35066d0f><h1 class=\"pricing-title blue\" data-v-35066d0f>Pay Once</h1><div class=\"discount\" data-v-35066d0f><h2 class=\"crossed\" data-v-35066d0f>8.99$</h2><span class=\"true offer\" data-v-35066d0f>5.99$</span></div><ul class=\"pricing-list\" data-v-35066d0f><li class=\"list-item\" data-v-35066d0f>Get 100 prompts</li><li class=\"list-item\" data-v-35066d0f>unlimited storage</li><li class=\"list-item\" data-v-35066d0f>Email support</li><li class=\"list-item\" data-v-35066d0f>Export to PRF/Print</li></ul></div></div>", 3)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("button", {
          onClick: goToHome,
          class: "home-button"
        }, "HOME"),
        (user.value && !user.value.is_subscribed)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              onClick: goToHome,
              class: "home-button"
            }, "SUBSCRIBE"))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}
}

})